module.exports = __webpack_public_path__ + "img/Unidad13-4.0583e56e.png";